import validator from 'validator';

function AddEditRewardValidation(data) {
  const errors = {};
  if (validator.isEmpty(data.title.trim())) errors.title = 'Please enter challenge title.';
  if (validator.isEmpty(data.description.trim()))
    errors.description = 'Please enter challenge description.';
  if (validator.isEmpty(data.points.trim())) errors.points = 'Please enter challenge points.';

  return { errors, isValid: Object.keys(errors).length <= 0 };
}

export default AddEditRewardValidation;
